import script from "./submit3.vue?vue&type=script&setup=true&lang=js"
export * from "./submit3.vue?vue&type=script&setup=true&lang=js"

import "./submit3.vue?vue&type=style&index=0&id=7d8f5de0&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d8f5de0"]])

export default __exports__